import { render } from "./RecentlyPlayedSlider.vue?vue&type=template&id=0d3ddf68&scoped=true"
import script from "./RecentlyPlayedSlider.vue?vue&type=script&lang=js"
export * from "./RecentlyPlayedSlider.vue?vue&type=script&lang=js"

import "./RecentlyPlayedSlider.vue?vue&type=style&index=0&id=0d3ddf68&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3ddf68"]])

export default __exports__